<template>
  <div class="products">
    <div class="header">
      <div class="form-inline">
        <h4 class="mr-5" v-if="showCards">Lista de Produtos</h4>
        <h4 class="mr-5" v-else>Pedido de Compras</h4>
        <button class="close-request ml-2 btn btn-primary" @click="hideCards()">
          <template v-if="showCards">
            <span class="mr-2">Fechar Pedido</span>
            <i class="fas fa-shopping-cart"></i>
          </template>
          <template v-else>
            <i class="fas fa-arrow-left"></i>
            <span class="ml-2">Voltar Lista</span>
          </template>
        </button>
      </div>
      <div class="form-inline">
        <input class="form-control mr-2" type="text" placeholder="Informe o produto" v-model="search">
        <button class="btn btn-outline-primary" type="button" @click="getProducts()">Localizar</button>
      </div>
    </div>
    <hr v-if="showCards">
    <div class="cards" :style="{ display: showCards ? 'flex' : 'none' }">
      <div class="card" v-for="(product, index) in products" :key="index">
          <div class="container">
            <div class="img row align-items-center">
              <img
                v-if="product.fileURL"
                :src=product.fileURL
                alt="Foto Produto"
                @click="showTemplate(product.name, product.application, product.fileURL)"
              >
              <img
                v-else
                src="../../assets/img/photographProduct.jpg"
                alt="Foto Produto"
              >
              <span class="promotion" v-if="product.promotion && !product.unavailable">Promoção</span>
              <span class="unavailable" v-if="product.unavailable">Produto Indisponível</span>
            </div>
            <div class="description row">
              <div class="card-body">
                <h6 class="card-title">{{ product.name }}</h6>
                 <p class="card-price"><span v-money-format="product.price" /></p>
              </div>
            </div>
            <div class="totals row align-items-center">
              <input type="number" min="0" class="form-control" id="inputQuantity" placeholder="Quantidade">
              <button class="btn btn-outline-primary fa fa-shopping-cart fa-2x" @click="saveItems(product, $event.target)"></button>
            </div>
        </div>
      </div>
    </div>
    <div class="show-template" :style="{ display: showModal ? 'block' : 'none' }">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ name }}</h5>
            <span class="close" @click="closeModal()">&times;</span>
          </div>
          <div class="modal-body mb-3">
            <img
              :src=image
              alt="Foto Produto"
            >
          </div>
          <div class="modal-body">
            <p>{{ application }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="request" :style="{ display: !showCards ? 'block' : 'none' }">
      <table class="table mt-3">
        <thead class="thead">
          <tr>
            <th scope="col">Item</th>
            <th scope="col" class="text-right">Quant</th>
            <th scope="col" class="text-right">Valor</th>
            <th scope="col" class="text-right">Total</th>
            <th scope="col" class="text-center">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in requestItens" :key="index">
            <td>{{ item.name }}</td>
            <td class="text-right">{{ item.quantity }}</td>
            <td class="text-right"><span v-money-format="item.price"/></td>
            <td class="text-right"><span v-money-format="item.total"/></td>
            <td class="text-center">
              <button class="btn btn-outline-danger" @click="deleteItem(item)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot class="font-weight-bold">
        <td colspan="3" class="text-right">Total</td>
        <td class="text-right" v-money-format="totalItens"></td>
        <td></td>
      </tfoot>
      </table>
      <hr>
      <form>
        <div class="row">
          <div class="form-group col-5">
            <label>Forma de Entrega</label>
              <select class="form-control" id="select-form-delivery">
                <option value=''>Selecione a forma de entrega</option>
                <option value="Sedex">SEDEX - a encomenda chega de três a sete dias úteis.</option>
                <option value="Pac">PAC - a encomenda leva de cinco a vinte dias úteis para chegar.</option>
              </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-5">
            <label>Observações</label>
            <textarea class="form-control" rows="4" v-model="request.observation"></textarea>
          </div>
        </div>
      </form>
      <div class="modal-footer mt-3">
        <button class="btn btn-secondary" @click.prevent="cancelRequest()">Cancelar</button>
        <button class="btn btn-primary" @click.prevent="saveRequest()">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
import date from 'date-and-time'

export default {
  name: 'ProductsList',
  data: () => ({
    products: [],
    showModal: false,
    showCards: true,
    search: '',
    name: '',
    application: '',
    image: '',
    request: {
      id: '',
      date: '',
      time: '',
      situation: '',
      idUser: '',
      nameUser: '',
      emailUser: '',
      formDelivery: '',
      observation: '',
      total: '',
      items: []
    },
    requestItens: [],
    totalItens: ''
  }),
  methods: {
    getProducts () {
      this.$firebase.database().ref('products').orderByChild('name').startAt(this.search).endAt(`${this.search}\uf8ff`)
        .on('value', (data) => {
          const values = data.val()
          if (values !== null) {
            this.products = Object.keys(values).map((items) => values[items]).sort(this.order)
          } else this.products = []
        })
      this.search = ''
    },
    order (a, b) {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    },
    saveItems (item, element) {
      const div = element.parentNode
      const inputQuantity = div.children[0]

      if (inputQuantity.value <= 0 || inputQuantity.value === '') {
        this.$root.$emit('Notification::show', {
          message: 'Favor informa a quantidade.',
          type: 'warning'
        })
      } else if (item.unavailable) {
        this.$root.$emit('Notification::show', {
          message: 'Produto Indisponível.',
          type: 'warning'
        })
        inputQuantity.value = ''
      } else {
        this.requestItens.push({
          id: item.id,
          name: item.name,
          price: item.price,
          quantity: inputQuantity.value,
          total: item.price * inputQuantity.value
        })
        this.getTotalItens()

        this.$root.$emit('Notification::show', {
          message: 'Produto salvo com sucesso.',
          type: 'success'
        })

        inputQuantity.value = ''
      }
    },
    deleteItem (item) {
      const resultado = confirm('Deseja excluir o item?')
      if (resultado === true) {
        const indice = this.requestItens.indexOf(item)
        this.requestItens.splice(indice, 1)

        this.$root.$emit('Notification::show', {
          message: 'Produto removido com sucesso.',
          type: 'success'
        })

        this.getTotalItens()

        if (this.requestItens < 1) {
          this.showCards = true
        }
      }
    },
    getTotalItens () {
      const total = this.requestItens.reduce(totalItems, 0)
      function totalItems (total, item) {
        return total + (item.quantity * item.price)
      }
      this.totalItens = total
    },
    saveRequest () {
      const resultado = confirm('Deseja salvar e enviar o pedido de compra?')
      if (resultado === true) {
        const selectFormDelivery = document.querySelector('#select-form-delivery')
        if (selectFormDelivery.options[selectFormDelivery.selectedIndex].value === '') {
          this.$root.$emit('Notification::show', {
            message: 'Favor informar a forma de entrega.',
            type: 'warning'
          })
        } else {
          this.$root.$emit('Spinner::show')
          try {
            this.ref = this.$firebase.database().ref('requests')

            this.$firebase.database().ref(`users/${window.uid}`)
              .on('value', (data) => {
                const userCurrent = data.val()

                this.request.id = this.ref.push().key
                this.request.date = date.format(new Date(), 'YYYY/MM/DD')
                this.request.time = date.format(new Date(), 'HH:mm')
                this.request.situation = 'Aberto'
                this.request.idUser = userCurrent.id
                this.request.nameUser = userCurrent.name
                this.request.emailUser = userCurrent.email
                this.request.formDelivery = selectFormDelivery.options[selectFormDelivery.selectedIndex].value
                this.request.total = this.totalItens
                this.request.items = this.requestItens
              })

            this.ref.child(this.request.id).set(this.request, (err) => {
              if (err) {
                this.$root.$emit('Notification::show', {
                  message: 'Não foi possivel inserir o pedido de compra, tente novamente.',
                  type: 'danger'
                })
              } else {
                this.$root.$emit('Notification::show', {
                  message: 'Pedido de compra salvo e enviado com sucesso.',
                  type: 'success'
                })
                this.search = ''
                this.request = []
                this.requestItens = []
                this.getProducts()
                this.showCards = true

                // Grava o counter dos pedidos
                this.saveCounterRequests()
              }
            })
          } catch (error) {
            this.$root.$emit('Notification::show', {
              message: 'Não foi possivel inserir o pedido de compra, tente novamente.',
              type: 'danger'
            })
            console.log(error)
          }
          this.$root.$emit('Spinner::hide')
        }
      }
    },
    cancelRequest () {
      if (this.requestItens.length > 0) {
        const resultado = confirm('Deseja cancelar o pedido de compra?')
        if (resultado === true) {
          this.requestItens = []
          this.showCards = true
        }
      }
    },
    saveCounterRequests () {
      this.ref = this.$firebase.database().ref('parameters/counter')
        .on('value', (data) => {
          this.counter = data.val()
        })

      const newCounter = this.counter + 1
      this.saveRef = this.$firebase.database().ref('parameters')
        .update({
          counter: newCounter
        })
    },
    showTemplate (name, application, image) {
      this.name = name
      this.application = application
      this.image = image
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    hideCards () {
      if (this.showCards === true && this.requestItens.length < 1) {
        this.$root.$emit('Notification::show', {
          message: 'Favor salvar um produto para fechar o pedido de compra.',
          type: 'warning'
        })
      } else {
        this.showCards = !this.showCards
      }
    }
  },
  created () {
    this.getProducts()
  }
}
</script>

<style lang="scss" scoped>
.products {
  padding: 40px 60px;
  height: 100%;
  .header {
    display: flex;
    justify-content: space-between;
  }
  .cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .card {
      width: 240px;;
      height: 380px;
      box-sizing: border-box;
      margin: 24px;
      transition: box-shadow ease .5s;
      border: 1px solid rgb(223, 223, 223);
      &:hover {
        box-shadow: 2px 2px 8px 3px rgba(73, 73, 73, 0.3);
      }
      .promotion {
        position: absolute;
        left: -10px;
        padding: 10px;
        top: -10px;
        background-color: #007BFF;
        color: #ffffff;
        font-weight: bold;
        border-radius: 5px;
      }
      .unavailable {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        top: 163px;
        text-align: center;
        color: red;
        font-weight: bold;
      }
      .container {
        .img {
          height: 180px;
          padding: 16px;
          img {
            height: 140px;
            width: 100%;
            &:hover {
              cursor: pointer;
            }
          }
        }
      .description {
          height: 120px;
          .card-price {
            font-size: 1.6em;
            font-weight: bold;
            color: #404040;
          }
        }
      .totals {
          height: 70px;
          padding: 8px;
          #inputQuantity {
            width: 130px;
            margin-left: 5px;
            margin-right: 20px;
          }
        }
      }
    }
  }
  .show-template {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    .close {
      &:hover {
        color: #000;
        cursor: pointer;
      }
    }
    .modal-body {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 500px;
      }
    }
  }
}
</style>
